import { Orientation, type SerializedDockview } from 'dockview';
import type { TypedGroupviewPanelState } from '../../../../types/LayoutConfig';
import { BRANCH, LEAF, MAIN_GROUP_ID } from '../../../Layout/tokens';
import { BLOTTER_PANELS_WITHOUT_ALLOCATIONS } from './shared';

const PANELS: Record<string, TypedGroupviewPanelState> = {
  careOrders: {
    id: 'careOrders',
    contentComponent: 'careOrders',
    params: {
      type: 'careOrders',
      tabs: undefined,
    },
    title: 'Care Orders',
  },
  ...BLOTTER_PANELS_WITHOUT_ALLOCATIONS,
};

const GRID: SerializedDockview['grid'] = {
  root: {
    type: BRANCH,
    data: [
      {
        type: LEAF,
        data: {
          views: ['careOrders'],
          activeView: 'careOrders',
          id: MAIN_GROUP_ID,
        },
        size: 800,
      },
      {
        type: BRANCH,
        data: [
          {
            type: LEAF,
            data: {
              views: [
                'orders',
                'trades',
                'otcDerivatives',
                'loans',
                'rfqs',
                'reconMismatches',
                'transfers',
                'hedgePositionStatus',
              ],
              activeView: 'rfqs',
              id: 'blotters',
            },
            size: 1400,
          },
          {
            type: LEAF,
            data: {
              views: ['positions', 'balances', 'credit'],
              activeView: 'positions',
              id: '1',
            },
            size: 900,
          },
        ],
        size: 500,
      },
    ],
    size: 2300,
  },
  width: 2300,
  height: 1300,
  orientation: Orientation.VERTICAL,
};

export const CARE_ORDERS_LAYOUT: SerializedDockview = {
  grid: GRID,
  panels: PANELS,
};
